import React, { lazy, useEffect, useState } from "react";
import "@Styles/global.less";
import { Score } from "@t8891/mobile";
import { host } from "@Services/url";
import { message } from "antd";
import { fetchKindsumComment } from "@Services/api";
import { replaceUrlWithAnchor, setUrlFormat } from "@Lib/common";
import { IKindsPcInfo } from "@Types/kindsum";
import { useAtom } from "jotai";
import { loginAtom } from "@Lib/jotai/login";
import { LikeIcon, MessageIcon } from "@t8891/icon";

interface IProps {
  dataSource?: IKindsPcInfo;
}

interface IComment {
  impress: {
    bad: {
      cat: string;
      id: string;
      kind_id: string;
      tag_name: string;
      tag_num: string;
    }[];
    goods: {
      cat: string;
      id: string;
      kind_id: string;
      tag_name: string;
      tag_num: string;
    }[];
  };

  ratList: {
    [key: string]: any;
  }[];

  ratingMark: {
    avg: string;
    ratio: string;
  };

  ratingTotal: string;
}

const KindSumComment: React.FC<IProps> = ({ dataSource }) => {
  const { brandName, kindName, newKindId, kindId } = dataSource ? dataSource : window;
  const [data, setData] = useState<IComment>();
  const [loginInfo] = useAtom(loginAtom);

  const getKindsumComment = async () => {
    const res = await fetchKindsumComment({ nk: newKindId, k: kindId });
    if (res.status == "200") {
      setData(res.data);
    } else {
      message.error(res.error.message);
    }
  };

  const handleClick = async () => {
    const m_id = !!loginInfo?.data?.m_id ? loginInfo?.data?.m_id : "";
    const baseUrl = `${host.c}/photoModel-cmtSubmit.html?nk=${newKindId}&k=${kindId}`;

    if (!m_id || m_id === "") {
      window.location.href = `https://www.8891.com.tw/user-signin.html?url=${baseUrl}`;
    } else {
      window.location.href = `${baseUrl}`;
    }
  };

  useEffect(() => {
    getKindsumComment();
  }, []);

  return (
    <section id='SpecificationCommentList' className='flex items-center mt-10 mb-30 flex-col justify-start'>
      <div className='text-20 h-44 mt-40 leading-40 w-full text-[#333] font-[600]'>{`${brandName} ${kindName} 車友交流`}</div>
      {data?.ratingTotal !== "0" ? (
        <>
          <div className='mt-24 w-full relative'>
            <div className='flex items-center'>
              <div className='w-154'>
                <Score
                  width={"24px"}
                  score={data?.ratingMark && data?.ratingMark.avg ? Number(data.ratingMark.avg) : 0}
                  color='#CC0000'
                />
              </div>
              <span className='text-[#CC0000] text-20 ml-8'>
                {data?.ratingMark && data?.ratingMark.avg ? data.ratingMark.avg : 0}分
              </span>
              <span className='text-[#747a8a] text-16 ml-20 text-primary'>{data?.ratingTotal || 0}篇評價</span>
            </div>
            {data?.impress && data?.impress.goods && data?.impress.goods.length > 0 && (
              <div className='text-[#FF0000] flex items-center mt-20'>
                <span className='text-16 font-medium'>優點：</span>
                {data.impress.goods.map((item) => (
                  <span key={item.id} className='mr-8 py-4 px-8 rounded-14 border-1 border-solid border-[#FF0000]'>
                    {item.tag_name}({item.tag_num || 0})
                  </span>
                ))}
              </div>
            )}
            {data?.impress && data?.impress.bad && data?.impress.bad.length > 0 && (
              <div className='text-[#333] flex items-center mt-20'>
                <span className='text-16 font-medium'>缺點：</span>
                {data.impress.bad.map((item) => (
                  <span key={item.id} className='mr-8 py-4 px-8 rounded-14 border-1 border-solid border-[#999999]'>
                    {item.tag_name}({item.tag_num || 0})
                  </span>
                ))}
              </div>
            )}

            <div
              className='w-124 h-76 flex items-center justify-center border-1 border-solid border-[#3264FF] text-[#3264FF] text-16 absolute right-0 top-0 rounded-8 cursor-pointer'
              onClick={() => handleClick()}
            >
              我要發佈評價
            </div>
          </div>

          <div className='w-full mt-20'>
            {data?.ratList &&
              data?.ratList.length > 0 &&
              data?.ratList.map((item) => (
                <a
                  key={item.id}
                  className='flex pb-20 border-0 border-b-1 border-solid border-[#e5e5e5] pt-20'
                  href={`/photoModel-comment.html?k=${item.kind_id}&myid=${item.myid}&mid=${item.m_id}`}
                  target='_blank'
                >
                  <img className='w-54 h-54 mx-16 rounded-full' src={item.member.m_headpic_new} alt='' />
                  <div className='flex flex-col relative flex-1'>
                    <div className='text-14 mb-10'>
                      <span className='text-[#3264FF] mr-16'>{item.title}</span>
                      <span className='text-[#333333] mr-8'>{item.member.name}</span>
                      <span className='text-[#333333]'>{item.update_date}</span>
                    </div>

                    <div
                      dangerouslySetInnerHTML={{ __html: replaceUrlWithAnchor(item.full_content) }}
                      className='text-[#333333] text-14 line-clamp-2 h-48 leading-20 max-h-40'
                    />

                    <span className='text-[#3264FF] text-14 leading-34'>詳細{">>"}</span>

                    <div className='absolute bottom-0 right-26 flex items-center text-[#333]'>
                      <div className='flex items-center mr-26 gap-2'>
                        <LikeIcon size={32} fill='#333' />
                        {item.support_num}
                      </div>
                      <div className='flex items-center gap-2'>
                        <MessageIcon size={32} fill='#333' />
                        {item.comment_num}
                      </div>
                    </div>
                  </div>
                </a>
              ))}
          </div>

          {Number(data?.ratingTotal) - Number(data?.ratList.length) > 0 && (
            <a
              href={`/${setUrlFormat(brandName)}/${setUrlFormat(kindName)}/Comment.html?nk=${newKindId}`}
              target='_blank'
              className='mx-auto mt-20 w-140 h-34 bg-[#f4f4f4] text-14 text-[#666] flex items-center justify-center rounded-4'
            >
              查看剩餘{Number(data?.ratingTotal) - Number(data?.ratList.length)}條評價
            </a>
          )}
        </>
      ) : (
        <div className='leading-60 text-center text-16'>
          暫無車友評價，快去
          <a target='_blank' className='text-[#1890ff] hover:text-[#1890ff]' onClick={() => handleClick()}>
            發布評價
          </a>
          吧！
        </div>
      )}
    </section>
  );
};

export default KindSumComment;
